import { observable } from 'mobx';

class ImportAssets {
  // 免费次数
  @observable freeCount: number = 0;
  // 需要导入的证书资产
  @observable resumeCertificationIds: number[] = [];
  // 需要导入的勋章资产
  @observable memberMedalRecordIds: number[] = [];
}

export default ImportAssets;
